/** EN uses Swedish values until translated. */
export const authTranslationsEn = {
    signIn: {
        helmetTitle: 'Log in',
        disabledUser: 'The user is disabled. Please contact info@financelab.se for more information.',
        incorrectUsernameOrPassword: 'Incorrect username or password.',
    },
    resetPassword: {
        helmetTitle: 'Forgot password',
        title: 'Forgot password',
        prompt: 'Submit your email adress to reset your password',
    },
    resetPasswordWithCode: {
        helmetTitle: 'Forgot password',
        title: 'Reset password',
        infoMessage:
            'If the provided user name exists, you will shortly receive a verification code to your email address. Use this here together with your new password.',
        infoMessageContactPrefix:
            'If you did not receive an email with a verification code, your user may be deactivated or you provided the wrong email address. Contact',
        infoMessageContactSuffix: 'us if you are experiencing any issues.',
        successMessage: 'Password has been reset. You may now',
        signInLink: 'log in',
        requestNewCode: 'Send new verification code.',
        submit: 'Reset password',
        fields: {
            email: 'Email address',
            code: 'Verification code',
            newPassword: 'New password',
            confirmPassword: 'Confirm new password',
        },
        validation: {
            emailInvalid: 'A correct email address is required',
            emailRequired: 'An email address must be provided',
            codeRequired: 'Missing verification code',
            passwordMinLength: 'The password must be at least 10 characters long',
            passwordRequired: 'A new password must be provided',
            passwordsMismatch: 'The passwords do not match',
            confirmRequired: 'Confirm password',
        },
        errors: {
            invalidCode: 'Incorrect verification code or server error',
        },
    },
    profile: {
        helmetTitle: 'User profile',
        title: 'User profile',
        changePassword: {
            title: 'Change password',
            submit: 'Change password',
            submitting: 'Changing...',
            currentPassword: 'Current password',
            newPassword: 'New password',
            newPasswordAgain: 'New password (again)',
            success: 'Password has been updated',
            updateFailed: 'Could not update the password. Please try again.',
            wrongCurrentPassword: 'Incorrect current password',
            invalidNewPassword: 'New password not allowed',
            validation: {
                fieldRequired: 'This field is required',
                passwordPattern:
                    'The password must contain at least 10 characters, one uppercase letter, one lowercase letter and one number',
                passwordsMismatch: 'The passwords do not match',
            },
        },
    },
}
